var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarAmenities = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 21,
  fill: "none",
  viewBox: "0 0 22 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M21.165 7.213c.399.1.698.3.798.7.1.299 0 .698-.3.898l-4.584 4.493 1.096 6.39c.1.399-.1.798-.398.998-.2.1-.399.2-.598.2h-.498L11 17.895l-5.68 2.995c-.4.2-.798.1-1.097-.1s-.498-.599-.399-.998l1.097-6.39L.336 8.911c-.299-.2-.398-.6-.299-.999.2-.4.499-.699.897-.699l6.279-.998 2.89-5.69c.299-.7 1.495-.7 1.794 0l2.89 5.79zm-6.179 5.99q0-.448.3-.898l3.587-3.494-4.883-.7c-.399 0-.698-.199-.797-.498L11 3.22 8.807 7.713c-.199.2-.498.499-.797.499l-4.883.699 3.588 3.394q.299.45.299.899l-.897 4.892 4.385-2.297q.449-.3.897 0l4.385 2.297z",
  clipRule: "evenodd"
})));
export default SvgStarAmenities;